import api from "./axios"

export function getCommittees() {
    return api.get(`/committees/`)
        .then(response => {
            //console.log("Fetched committees:", response.data);
            return response.data;
        })
        .catch(error => {
            console.error("Error fetching committees:", error);
            throw error;
        });
}

// Helper function to get committee from id
export function getCommitteeFromId(committeeId) {
    return api.get(`/committees/?id=${committeeId}`)
        .then(response => {
            return response.data[0];    // assuming there's always only one match
        })
        .catch(error => {
            console.error("Error fetching committee:", error);
            throw error;
        });
}

export function getIdFromCommittee(committeeName) {
    // Assuming your backend supports filtering by name via query parameters
    return api.get(`/committees/?name=${committeeName}`)
        .then(response => {
            // Check if a match was found in the returned array
            if (response.data && response.data.length > 0) {
                return response.data[0].committee_id; 
            }
            throw new Error("Committee not found");
        })
        .catch(error => {
            console.error("Error fetching committee ID:", error);
            throw error;
        });
}

export async function addCommitteeMembership(user_id, committee_id, role = 'Member') {
    try {
        const res = await api.post(`/committees/memberships/${user_id}/`, {
            committee_id: committee_id,
            role: role
        });
        return res.data;
    } catch (error) {
        console.error("Error adding membership:", error);
        throw error;
    }
}

export async function deleteCommitteeMembership(user_id, committee_id) {
    try {
        // Axios delete requests with a body require the 'data' key
        const res = await api.delete(`/committees/memberships/${user_id}/`, {
            data: { committee_id: committee_id }
        });
        return res.data;
    } catch (error) {
        console.error("Error deleting membership:", error);
        throw error;
    }
}